import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';

import i18n from '@/initI18n';

import { Field } from '@/shared/api/rest/models';
import Pagination from '@/shared/components/Pagination.vue';
import ButtonWithArrow from '@/shared/components/buttons/ButtonWithArrow.vue';

import FormFieldSetCreateFields from './FormFieldSetCreateFields.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateFieldsSidebar',
  props: {
    currentFieldId: null,
    newFields: null,
    invalidNewFields: null,
    errorMessage: null,
    visibleColumns: null,
    missingName: { type: Boolean },
    missingCompany: { type: Boolean },
    uniqueNameViolation: { type: Boolean }
  },
  emits: ["update:createFieldsCurrentStep", "update:newFields", "closeEditMode", "save:newFields"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:createFieldsCurrentStep', value: number): void;
  (e: 'update:newFields', value: Field[]): void;
  (e: 'closeEditMode'): void;
  (e: 'save:newFields'): void;
}), expose: any, slots: any, attrs: any }) {

const t = i18n.translate;



const currentStep = ref(0);

watch(currentStep, (val) => emit('update:createFieldsCurrentStep', val));



function updateNewFields(fields: Field[]) {
  emit('update:newFields', fields);
}

function onButtonBack() {
  if (currentStep.value === 0) {
    emit('closeEditMode');
  } else if (currentStep.value === 1) {
    currentStep.value = 0;
  }
}

function onButtonNext() {
  if (currentStep.value === 0) {
    currentStep.value = 1;
  } else if (currentStep.value === 1) {
    emit('save:newFields');
  }
}

return { __sfc: true,t, currentStep, emit, updateNewFields, onButtonBack, onButtonNext, Pagination, ButtonWithArrow, FormFieldSetCreateFields }
}

})